const elements = {
  config: '#c-header-ajax-content',
}

export class NotificationRepository {
    constructor() {
      $(document).ready(() => {
        this.statusUrl = $(elements.config).attr('data-notification-status');
        this.articlesUrl = $(elements.config).attr('data-notification-articles');
        this.systemUrl = $(elements.config).attr('data-notification-system');
      });
    }
    getInterval() {
        const setting = window.rmpl.get('notifications', 'refresh.interval_sec');
        const interval = isNaN(setting) ? 30 : Number(setting);

        return interval * 1000;
    }
    checkStatus() {
        const executeLoadingData = (resolve, reject) => {
        $.get(this.statusUrl)
            .done((response) => {
                const { status, data, redirectURL } = response;

                if (status === 'ok') {
                    resolve(data.notifications);
                } else if (status === 'error') {
                    reject(data.error);
                } else if (status === 'redirect') {
                    window.location.href = redirectURL;
                }
            })
            .fail((error) => {
                reject(error);
            });
        };
        return new Promise(executeLoadingData);
    }
    checkArticlesNotifications() {
        const executeLoadingData = (resolve, reject) => {
        $.get(this.articlesUrl)
            .done((response) => {
                const { status, data, redirectURL } = response;

                if (status === 'ok') {
                    resolve(data);
                } else if (status === 'error') {
                    reject(data.error);
                } else if (status === 'redirect') {
                    window.location.href = redirectURL;
                }
            })
            .fail((error) => {
                reject(error);
            });
        };
        return new Promise(executeLoadingData);
    }
    checkSystemNotifications(last) {
        let url = this.systemUrl;
        if (last !== void 0) {
            url += '?last=' + last;
        }

        const executeLoadingData = (resolve, reject) => {
        $.get(url)
            .done((response) => {
                const { status, data, redirectURL } = response;

                if (status === 'ok') {
                    resolve(data);
                } else if (status === 'error') {
                    reject(data.error);
                } else if (status === 'redirect') {
                    window.location.href = redirectURL;
                }
            })
            .fail((error) => {
                reject(error);
            });
        };
        return new Promise(executeLoadingData);
    }
};

export const notificationRepository = new NotificationRepository();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/repositories/notificationRepository.js